import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CertificateCard = ({ certificate, onDownload, onShare }) => {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all group">
      <div className="relative h-48 bg-gradient-to-br from-primary to-secondary overflow-hidden">
        <Image 
          src={certificate?.image}
          alt={certificate?.imageAlt}
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <Icon name="Award" size={48} className="mx-auto mb-2" />
            <h3 className="text-xl font-bold">{certificate?.title}</h3>
          </div>
        </div>
      </div>
      <div className="p-6 space-y-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Building2" size={16} />
            <span>{certificate?.issuer}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} />
            <span>Issued: {certificate?.issueDate}</span>
          </div>
          {certificate?.expiryDate && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} />
              <span>Expires: {certificate?.expiryDate}</span>
            </div>
          )}
          <div className="flex items-center gap-2 text-sm">
            <Icon name="CheckCircle2" size={16} className="text-success" />
            <span className="text-success font-medium">Verified</span>
          </div>
        </div>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            size="sm" 
            iconName="Download" 
            iconPosition="left"
            onClick={() => onDownload(certificate?.id)}
            className="flex-1"
          >
            Download
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            iconName="Share2" 
            iconPosition="left"
            onClick={() => onShare(certificate?.id)}
            className="flex-1"
          >
            Share
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CertificateCard;